/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DefaultTargetContainerQuantityInfo } from '../../models/default-target-container-quantity-info';

export interface GetDefaultTargetContainerQuantity$Params {
  productionOrderId: number;
}

export function getDefaultTargetContainerQuantity(http: HttpClient, rootUrl: string, params: GetDefaultTargetContainerQuantity$Params, context?: HttpContext): Observable<StrictHttpResponse<DefaultTargetContainerQuantityInfo>> {
  const rb = new RequestBuilder(rootUrl, getDefaultTargetContainerQuantity.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DefaultTargetContainerQuantityInfo>;
    })
  );
}

getDefaultTargetContainerQuantity.PATH = '/api/v1/ProductionOrder/{productionOrderId}/GetDefaultTargetContainerQuantity';
